import { render } from "./ReflexologieMassageShiatsu.vue?vue&type=template&id=1284fc61&scoped=true"
const script = {}

import "./ReflexologieMassageShiatsu.vue?vue&type=style&index=0&id=1284fc61&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1284fc61"]])

export default __exports__